<template>
<div class="BasketCounter">
  <div class="price">
    <div class="d-flex align-center gap-3 justify-end">
      <v-btn
        :icon="true"
        :depressed="true"
        :disabled="!service.is_visible"
        @click="changeAmount(service.id,service.quantity - 1)"
      >
            <span class="cursor-pointer d-flex">
              <svg width="24" height="4" viewBox="0 0 24 4" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <rect width="24" height="3.5" fill="#25325F"/>
              </svg>
            </span>
      </v-btn>
      <v-text-field
        outlined
        dense
        class=" count-input"
        hide-details
        type="number"
        min="1"
        :max="MAX_QUANTITY"
        :disabled="!service.is_visible"
        :value="draft"
        @focus="editing = true"
        @blur="editing = false"
        @input="draft = $event"
        @change="applyDraft"
        @keyup.enter="$event.target.blur()"
      />
      <v-btn
        :icon="true"
        :depressed="true"
        :disabled="!service.is_visible || service.quantity >= MAX_QUANTITY"
        @click="changeAmount(service.id,service.quantity + 1)"
      >
            <span class="cursor-pointer d-flex">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.2857 13.7143H0V10.2857H10.2857V0H13.7143V10.2857H24V13.7143H13.7143V24H10.2857V13.7143Z" fill="#25325F"/>
            </svg>
          </span>
      </v-btn>
    </div>

  </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import { MAX_QUANTITY, parseQuantity } from '@/components/basket/quantity';

/**
 * Компонент: BasketCounter
 * Описание:
 */
export default {
  name: 'BasketCounter',

  components: {},

  props: {
    id: {
      type: Number,
      required: true,
    }
  },

  data() {
    // draft — текст в поле; пока поле в фокусе, обновление корзины его не затирает
    return { MAX_QUANTITY, draft: null, editing: false };
  },

  computed: {
    ...mapGetters({
      itemInBasket: 'basket/basket/itemInBasket'
    }),
    service() {
      return this.itemInBasket(this.id);
    }
  },

  watch: {
    // Поле показывает черновик ввода; когда количество в корзине обновилось, подтягиваем его
    'service.quantity': {
      immediate: true,
      handler(quantity) {
        if (!this.editing) this.draft = quantity;
      },
    },
  },

  created() {
  },

  mounted() {
  },

  beforeDestroy() {
  },

  methods: {
    ...mapActions({
      fetchUserBasket: 'basket/basket/fetchUserBasket',
      changeCount: 'basket/basket/changeCount',
    }),
    async changeAmount(id, count) {
      const data = {
        id,
        quantity: count,
      };
      try {
        await this.changeCount(data);
      } catch (e) {
        this.$toast.error('Не удалось изменить количество', '', { position: 'topRight' });
      }
      // Корзину перечитываем и после сбоя: поле должно показать то, что реально на сервере
      try {
        await this.fetchUserBasket();
      } catch (e) {
        // без свежей корзины остаётся прежнее значение
      }
      if (this.service) this.draft = this.service.quantity;
    },
    // Вписанное руками число принимаем, если оно целое от 1 до MAX_QUANTITY; иначе возвращаем прежнее
    async applyDraft() {
      const quantity = parseQuantity(this.draft);
      if (!quantity || quantity === this.service.quantity) {
        this.draft = this.service.quantity;
        return;
      }
      await this.changeAmount(this.service.id, quantity);
    }
  },
};
</script>

<style scoped lang="scss">
.BasketCounter {
  & .price{
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-end;
    gap: 12px;
    padding: 2px 0;
    & .count-input{
      max-width: 100px;
      max-height: 40px;
      text-align: center;
      & ::v-deep input{
        text-align: center;
      }
    }
    & .price-per-item{
      font-weight: 600;
      font-size: 16px;
    }
    & .action{
      .v-btn{
        padding: 12px;
        border: 1px solid var(--color-grey-500);
        border-radius: 50%;
        height: 40px;
        width: 40px;
        & .v-icon{
          font-size: 21px;
        }
      }
    }
  }
  /* Стили компонента */
}
</style>
